module.exports = __webpack_public_path__ + "img/skillsC-4.bba86ecc.png";